import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../Layout/Layout";
import ItemService from "../services/supplier_appCommonService";
import { MultiselectField } from "../Components/formElements/MultiselectField";
import RichTextEditor from "../Components/Editor/RichTextEditor";
import "./email.css";
import SupplierConstants from "../common/SupplierConstants";
import { useNavigate } from "react-router-dom";

const EmailSender = () => {
  localStorage.setItem("menu", "Contract");
  localStorage.setItem("submenu", "Contract DRAFT/FINAL");
  const  navigate = useNavigate();
  const [getVendorDropdownData, setVendorDropdownData] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [editorContent, setEditorContent] = useState("");
  const [subject, setSubject] = useState("");
  const [loading, setLoading] = useState(false);

  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  const getMasterDataFunc = async () => {
    const obj = {};

    const item = await ItemService.getSupplierDatail(obj);

    if (item?.status === 200) {
      setVendorDropdownData(item.data || []);
      
    } else {
      setVendorDropdownData([]);
    }
  };

  useEffect(() => {
    getMasterDataFunc();
     // eslint-disable-next-line 
  }, []);

  // Handles MultiSelect values
  const handleVendorChange = (obj) => {
    console.log("Selected Object :", obj);

    const selected = obj?.selected || [];
    setSelectedVendors(selected);
  };

  //   const handleSubmit = async () => {
  //   if (selectedVendors.length === 0) {
  //     alert("Please select at least one recipient.");
  //     return;
  //   }

  //   if (!subject.trim()) {
  //     alert("Please enter subject.");
  //     return;
  //   }

  //   if (!editorContent.trim()) {
  //     alert("Please enter message.");
  //     return;
  //   }

  //   const obj = {
  //     data: {
  //       toEmailId: selectedVendors.map((item) => item.email),
  //       ccEmailId: "",
  //       subject: subject,
  //       message: editorContent,
  //     },
  //   };

  //   console.log("Payload :", obj);

  //   try {
  //     const response = await ItemService.sendCustomEmail(obj);

  //     if (response?.status === 200) {
  //       alert("Email sent successfully");

  //       setSelectedVendors([]);
  //       setSubject("");
  //       setEditorContent("");
  //     } else {
  //       alert(response?.message || "Unable to send email");
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     alert("Something went wrong");
  //   }
  // };
  const handleSubmit = async () => {
    if (loading) {
      return; // Prevent multiple submissions while loading
    }
    if (selectedVendors.length === 0) {
      alert("Please select at least one recipient.");
      return;
    }

    if (!subject.trim()) {
      alert("Please enter subject.");
      return;
    }

    if (!editorContent.trim()) {
      alert("Please enter message.");
      return;
    }
    setLoading(true);
    const obj = {
      data: {
        toEmailId: selectedVendors.map((item) => item.email),
        vendors: selectedVendors, // <-- Add this
        ccEmailId: "",
        subject: subject,
        message: editorContent,
      },
    };

    console.log("Payload :", obj);

    try {
      const response = await ItemService.sendCustomEmail(obj);

      if (response?.status === 200) {
        alert("Email sent successfully");

        setSelectedVendors([]);
        setSubject("");
        setEditorContent("");
        navigate(SupplierConstants.SENT_EMAIL)
      } else {
        alert(response?.message || "Unable to send email");
      }
    } catch (err) {
      console.log(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="justify-content-center subContent">
        <Col xs={12} className="rightSide">
          <div className="rightSideInner">
            <div className="mb-4">
              <h2 className="mainTitle">Email Compose</h2>
            </div>

            <div className="emailComposeCard">
              {/* Recipients */}
              <Row>
                <Col xs={12}>
                  <MultiselectField
                    className="dropdownOption"
                    label="Recipients"
                    placeholder="Select Suppliers"
                    data={getVendorDropdownData}
                    id="vendorName"
                    name="vendorName"
                    required={true}
                    setValue={selectedVendors}
                    getvalue={handleVendorChange}
                  />
                </Col>
              </Row>

              {/* Email List */}
              {selectedVendors.length > 0 && (
                <Row className="mt-3">
                  <Col xs={12}>
                    <label className="composeLabel">Email Recipients</label>

                    <div className="d-flex flex-wrap gap-2 mt-2">
                      {selectedVendors.map((vendor) => (
                        <div key={vendor.id} className="emailHighlight">
                          <i className="bi bi-envelope-fill me-2"></i>
                          {vendor.email}
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
              )}

              {/* Subject */}
              <Row className="mt-4">
                <Col xs={12}>
                  <label className="composeLabel">Subject</label>

                  <input
                    type="text"
                    className="composeInput"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder="Enter Subject"
                  />
                </Col>
              </Row>

              {/* Message */}
              <Row className="mt-4">
                <Col xs={12}>
                  <RichTextEditor
                    value={editorContent}
                    onChange={handleEditorChange}
                  />
                </Col>
              </Row>

              {/* Submit */}
              <Row className="mt-4">
                <Col className="text-end">
                  <button className="btn btn-primary" onClick={handleSubmit}>
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Sending...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default EmailSender;
